import React, { useState, useEffect } from 'react';
import './DadosOrgao.css';

import API_BASE_URL from '../../../config/api';
const DadosOrgao = () => {
  const [formData, setFormData] = useState({
    NM_EMPRESA: '',
    CNPJ: '',
    ENDERECO: '',
    NUMERO: '',
    COMPLEMENTO: '',
    BAIRRO: '',
    CIDADE: '',
    CEP: '',
    UF: '',
    FONE: '',
    CELULAR: '',
    EMAIL: '',
    HOMEPAGE: '',
    IMAGEM_LOGO: '',
    PREFEITO: '',
    VICE_PREFEITO: '',
    SECRETARIA: '',
    SECRETARIO: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [id, setId] = useState(null);
  const nomeEmpresaRef = React.useRef(null);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!loading && nomeEmpresaRef.current) {
      nomeEmpresaRef.current.focus();
    }
  }, [loading]);

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/empresa`);
      if (response.ok) {
        const data = await response.json();
        console.log('Dados recebidos do backend:', data); // LOG DEBUG
        setFormData(data);
        setId(data.CD_EMPRESA);
      } else {
        console.error('Erro ao buscar dados do órgão');
      }
    } catch (error) {
      console.error('Erro de conexão:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prev => ({
          ...prev,
          IMAGEM_LOGO: reader.result // Base64 string
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!id) return;

    setSaving(true);
    try {
      const response = await fetch(`${API_BASE_URL}/empresa/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        alert('Dados atualizados com sucesso!');
        fetchData(); // Recarrega para garantir sincronia
      } else {
        alert('Erro ao atualizar dados.');
      }
    } catch (error) {
      console.error('Erro ao salvar:', error);
      alert('Erro de conexão ao salvar.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="loading">Carregando...</div>;

  return (
    <div className="dados-orgao-container" style={{ width: '100%', maxWidth: '100%', margin: 0, padding: '10px' }}>
      <div className="page-header">
        <h2>Dados do Órgão</h2>
      </div>

      <div className="form-container" style={{ width: '100%', maxWidth: '100%', display: 'block' }}>
        <form onSubmit={handleSubmit}>
          <div className="form-section">
            <h3>Identificação</h3>
            <div className="form-row">
              <div className="form-group col-8">
                <label>Nome do Órgão / Prefeitura:</label>
                <input
                  type="text"
                  name="NM_EMPRESA"
                  value={formData.NM_EMPRESA || ''}
                  onChange={handleChange}
                  maxLength={60}
                  ref={nomeEmpresaRef}
                  style={{ fontWeight: 'bold' }}
                />
              </div>
              <div className="form-group col-4">
                <label>CNPJ:</label>
                <input
                  type="text"
                  name="CNPJ"
                  value={formData.CNPJ || ''}
                  onChange={handleChange}
                  maxLength={20}
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3>Endereço e Contato</h3>
            <div className="form-row">
              <div className="form-group col-6">
                <label>Endereço:</label>
                <input
                  type="text"
                  name="ENDERECO"
                  value={formData.ENDERECO || ''}
                  onChange={handleChange}
                  maxLength={100}
                />
              </div>
              <div className="form-group col-2">
                <label>Número:</label>
                <input
                  type="text"
                  name="NUMERO"
                  value={formData.NUMERO || ''}
                  onChange={handleChange}
                  maxLength={6}
                />
              </div>
              <div className="form-group col-4">
                <label>Complemento:</label>
                <input
                  type="text"
                  name="COMPLEMENTO"
                  value={formData.COMPLEMENTO || ''}
                  onChange={handleChange}
                  maxLength={40}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-4">
                <label>Bairro:</label>
                <input
                  type="text"
                  name="BAIRRO"
                  value={formData.BAIRRO || ''}
                  onChange={handleChange}
                  maxLength={100}
                />
              </div>
              <div className="form-group col-4">
                <label>Cidade:</label>
                <input
                  type="text"
                  name="CIDADE"
                  value={formData.CIDADE || ''}
                  onChange={handleChange}
                  maxLength={100}
                />
              </div>
              <div className="form-group col-2">
                <label>UF:</label>
                <input
                  type="text"
                  name="UF"
                  value={formData.UF || ''}
                  onChange={handleChange}
                  maxLength={10}
                />
              </div>
              <div className="form-group col-2">
                <label>CEP:</label>
                <input
                  type="text"
                  name="CEP"
                  value={formData.CEP || ''}
                  onChange={handleChange}
                  maxLength={10}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-3">
                <label>Telefone:</label>
                <input
                  type="text"
                  name="FONE"
                  value={formData.FONE || ''}
                  onChange={handleChange}
                  maxLength={12}
                />
              </div>
              <div className="form-group col-3">
                <label>Celular:</label>
                <input
                  type="text"
                  name="CELULAR"
                  value={formData.CELULAR || ''}
                  onChange={handleChange}
                  maxLength={12}
                />
              </div>
              <div className="form-group col-6">
                <label>E-mail:</label>
                <input
                  type="email"
                  name="EMAIL"
                  value={formData.EMAIL || ''}
                  onChange={handleChange}
                  maxLength={60}
                />
              </div>
            </div>
             <div className="form-row">
               <div className="form-group col-12">
                <label>Homepage:</label>
                <input
                  type="text"
                  name="HOMEPAGE"
                  value={formData.HOMEPAGE || ''}
                  onChange={handleChange}
                  maxLength={60}
                />
              </div>
             </div>
          </div>

          <div className="form-section">
            <h3>Gestão</h3>
            <div className="form-row">
              <div className="form-group col-6">
                <label>Prefeito:</label>
                <input
                  type="text"
                  name="PREFEITO"
                  value={formData.PREFEITO || ''}
                  onChange={handleChange}
                  maxLength={50}
                />
              </div>
              <div className="form-group col-6">
                <label>Vice-Prefeito:</label>
                <input
                  type="text"
                  name="VICE_PREFEITO"
                  value={formData.VICE_PREFEITO || ''}
                  onChange={handleChange}
                  maxLength={50}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-6">
                <label>Secretaria:</label>
                <input
                  type="text"
                  name="SECRETARIA"
                  value={formData.SECRETARIA || ''}
                  onChange={handleChange}
                  maxLength={50}
                />
              </div>
              <div className="form-group col-6">
                <label>Secretário:</label>
                <input
                  type="text"
                  name="SECRETARIO"
                  value={formData.SECRETARIO || ''}
                  onChange={handleChange}
                  maxLength={50}
                />
              </div>
            </div>
          </div>

          <div className="form-section">
             <h3>Logomarca</h3>
             <div className="form-row logo-row">
                <div className="form-group col-6">
                  <label>Selecione a imagem:</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                  <small>A imagem será convertida para Base64.</small>
                </div>
                <div className="form-group col-6 logo-preview-container">
                  {formData.IMAGEM_LOGO ? (
                    <div className="logo-preview">
                       <img src={formData.IMAGEM_LOGO} alt="Logo do Órgão" />
                    </div>
                  ) : (
                    <div className="logo-placeholder">Sem logo</div>
                  )}
                </div>
             </div>
          </div>

          <div className="form-actions-bottom">
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? 'Salvando...' : 'Salvar Alterações'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DadosOrgao;
